export default function WhyNeedSection() {
  const cards = [
    {
      icon: 'ri-shopping-cart-2-line',
      title: 'Order Tracking',
      desc: 'Track every purchase from product selection to delivery with real-time status updates and detailed logging for each item in your haul.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cost Management',
      desc: 'Calculate product cost, shipping fees, currency conversion, and total expenses — all in one automated dashboard that updates as you add items.',
    },
    {
      icon: 'ri-archive-line',
      title: 'Warehouse Organization',
      desc: 'Manage stored items efficiently, track free storage windows, schedule consolidation, and plan shipments with complete visibility.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Decision Making',
      desc: 'Compare products, shipping options, and carriers side by side to make data-driven choices that maximize value and minimize cost.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
              Why Spreadsheets Matter
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
              Why You Need a Basetao Spreadsheet
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              A structured spreadsheet transforms chaotic shopping into a streamlined, professional workflow
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {cards.map((card) => (
              <div
                key={card.title}
                className="bg-background-50 rounded-lg border border-background-200/60 p-6 hover:border-accent-300 transition-all duration-200"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                  <i className={`${card.icon} text-xl`}></i>
                </div>
                <h3 className="font-semibold text-foreground-900 mb-2 text-base">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}